/* tslint:disable */
// @ts-nocheck
/* eslint-disable */
/**
 * Rana simulation API
 *
 * The version of the OpenAPI document: v3
 * Contact: info@nelen-schuurmans.nl
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
import type { LeveeMaterialEnum } from "./LeveeMaterialEnum";
import {
  LeveeMaterialEnumFromJSON,
  LeveeMaterialEnumFromJSONTyped,
  LeveeMaterialEnumToJSON,
  LeveeMaterialEnumToJSONTyped,
} from "./LeveeMaterialEnum";

/**
 * A type of `ModelSerializer` that uses
 * hyperlinked relationships with compound keys instead
 * of primary key relationships.  Specifically:
 * * A 'url' field is included instead of the 'id' field.
 * * Relationships to other instances are hyperlinks, instead of primary keys.
 * NOTE: this only works with DRF 3.1.0 and above.
 * @export
 * @interface PotentialBreach
 */
export interface PotentialBreach {
  /**
   *
   */
  readonly url?: string;
  /**
   *
   */
  connectedPntId: number;
  /**
   *
   */
  leveeMaterial: LeveeMaterialEnum;
  /**
   *
   */
  lineId: number;
  /**
   *
   */
  maximumBreachDepth: number;
  /**
   *
   */
  readonly threedimodel?: string;
  /**
   *
   */
  readonly id?: number;
}

/**
 * Check if a given object implements the PotentialBreach interface.
 */
export function instanceOfPotentialBreach(value: object): value is PotentialBreach {
  if (
    (!("connectedPntId" in (value as Record<string, any>)) &&
      !("connected_pnt_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["connectedPntId"] === undefined &&
      (value as Record<string, any>)["connected_pnt_id"] === undefined)
  )
    return false;
  if (
    (!("leveeMaterial" in (value as Record<string, any>)) &&
      !("levee_material" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["leveeMaterial"] === undefined &&
      (value as Record<string, any>)["levee_material"] === undefined)
  )
    return false;
  if (
    (!("lineId" in (value as Record<string, any>)) &&
      !("line_id" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["lineId"] === undefined &&
      (value as Record<string, any>)["line_id"] === undefined)
  )
    return false;
  if (
    (!("maximumBreachDepth" in (value as Record<string, any>)) &&
      !("maximum_breach_depth" in (value as Record<string, any>))) ||
    ((value as Record<string, any>)["maximumBreachDepth"] === undefined &&
      (value as Record<string, any>)["maximum_breach_depth"] === undefined)
  )
    return false;
  return true;
}

export function PotentialBreachFromJSON(json: any): PotentialBreach {
  return PotentialBreachFromJSONTyped(json, false);
}

export function PotentialBreachFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PotentialBreach {
  if (json == null) {
    return json;
  }
  return {
    url: json["url"] == null ? undefined : json["url"],
    connectedPntId: json["connected_pnt_id"],
    leveeMaterial: LeveeMaterialEnumFromJSON(json["levee_material"]),
    lineId: json["line_id"],
    maximumBreachDepth: json["maximum_breach_depth"],
    threedimodel: json["threedimodel"] == null ? undefined : json["threedimodel"],
    id: json["id"] == null ? undefined : json["id"],
  };
}

export function PotentialBreachToJSON(json: any): PotentialBreach {
  return PotentialBreachToJSONTyped(json, false);
}

export function PotentialBreachToJSONTyped(
  value?: Omit<PotentialBreach, "url" | "threedimodel" | "id"> | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    connected_pnt_id: value["connectedPntId"],
    levee_material: LeveeMaterialEnumToJSON(value["leveeMaterial"]),
    line_id: value["lineId"],
    maximum_breach_depth: value["maximumBreachDepth"],
  };
}
